import { GameState } from '../types';
import { WORLD_W, WORLD_H } from '../constants';

export function updateProjectiles(state: GameState, dt: number): void {
  for (const proj of state.projectiles) {
    proj.x += proj.dx * dt;
    proj.y += proj.dy * dt;
    proj.lifetime -= dt;
  }

  // Remove expired or out-of-bounds
  state.projectiles = state.projectiles.filter(p =>
    p.lifetime > 0 &&
    p.x > -50 && p.x < WORLD_W + 50 &&
    p.y > -50 && p.y < WORLD_H + 50
  );
}
